import type { RouteRecordRaw } from 'vue-router'
import type { Profile } from '@/types/profile'
import { createRouter, createWebHashHistory } from 'vue-router'
import { uc } from '@/api/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: async () => import('@/views/layout/index.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: async () => import('@/views/home/index.vue'),
      },
      {
        path: 'register',
        name: 'Register',
        meta: {
          title: '申请入驻',
        },
        component: async () => import('@/views/register/index.vue'),
      },
      {
        path: 'register-detail',
        name: 'RegisterDetail',
        meta: {
          title: '查看信息',
        },
        component: async () => import('@/views/register/detail.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: async () => import('@/views/login/index.vue'),
  },
  {
    path: '/init',
    name: 'Init',
    component: async () => import('@/views/init/index.vue'),
  },
  {
    path: '/forget-pwd',
    name: 'ForgetPwd',
    component: async () => import('@/views/forget-pwd/index.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to) => {
  if (to.name === 'Login' || to.name === 'ForgetPwd') {
    return true
  }
  let me: Profile | null = null
  try {
    const res = await uc()
    me = res.data
  } catch (err) {
  }
  if (!me) {
    return false
  }

  if (!me.is_init) {
    if (to.name === 'Init') {
      return true
    }
    return {
      name: 'Init',
    }
  }
  if (to.name === 'Init') {
    return {
      name: 'Home',
    }
  }
})
export default router
